/* eslint-disable no-unused-vars */
import PushPinIcon from '@mui/icons-material/PushPin';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AirlineStopsIcon from '@mui/icons-material/AirlineStops';
import { SelectPicker } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { WhereToVote } from '@mui/icons-material';
import { MapPinOff } from 'lucide-react';
import GlobalSearch from '@/Components/globalSearch/search';
import drawerActions from '@/Actions/drawer.actions';
import StockHistoryDrawer from '@/Components/Drawers/StockHistoryDrawer/StockHistoryDrawer';
import { ListTable } from '@/Components/ListTable';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import { BackdropLoader } from '@/Components/Loaders';
import { notificationServices } from '@/Services';
import assetActions from '@/Actions/asset.actions';

const SPECIAL_COLUMNS = [
	{
		title: 'Asset Type Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Asset Type Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Asset Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Capacity',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Movable',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Traceble',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Current Stock',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Transit Stock',
		config: {
			type: 'DATA',
		},
	},
];
const colMap = {
	'Asset Type Id': 'assetTypeId',
	'Asset Type Name': 'assetType',
	'Current Stock': 'id',
	'Transit Stock': 'transitStock',
	'Asset Category': 'assetTypeId',
	Capacity: 'assetTypeId',
	Movable: 'assetTypeId',
	Traceble: 'assetTypeId',
};

const AssetReport = () => {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [store, setStore] = useState(null);
	const [searchValue, setSearchValue] = useState('');
	const stores = useSelector((state) => state?.navigation?.permittedStores);
	const assetTypes = useSelector((state) => state?.assets?.list);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(assetActions.fetchAssetList());
	}, []);

	const handleOpenDrawer = (id) => {
		const item = data?.find((ele) => ele?.id === id);
		dispatch(drawerActions.toggleStockHistoryDrawer(true, {
			heading: `Asset Trail of ${item?.assetType}`,
			currentStock: item?.currentStock,
			itemDetails: {
				...item,
				assetTypeId: item?.assetTypeId,
				assetTypeName: item?.assetType,
			},
			selectedStore: store,
			type: 'ASSET_REPORT',
		}));
	};
	// api Calling
	const fetchData = async (value) => {
		setLoading(true);
		try {
			const req = {
				data: {
					storeId: value,
				},
			};
			const response = await inventoryAnalyticsServices.fetchAssetReport(req);
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: 'Fetched successfully',
				});
				setData(response?.data);
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.response?.data?.message || 'Something went wrong',
			});
		} finally {
			setLoading(false);
		}
	};
	const selectStore = (value) => {
		const selectedStore = stores?.find((ele) => ele?.id === value);
		setStore({
			id: selectedStore?.id,
			title: selectedStore?.name,
		});
		fetchData(value);
	};

	const specialItems = {
		'Asset Type Id': (id, item) => {
			return <span>{item}</span>;
		},
		'Asset Type Name': (_, item) => {
			return (
				<div className='flex justify-center items-center gap-2'>
					<div className='text-start w-[100px] text-nowrap '>{item}</div>
				</div>
			);
		},
		'Current Stock': (id, item) => {
			const currentStock = data?.find((ele) => ele?.id === id)?.currentStock;
			return (
				<div className='flex items-center justify-center gap-2'>
					<div className='w-[50px] text-nowrap flex items-center text-start gap-2'>
						<span className='mr-2'>{currentStock}</span>
						<span
							onClick={() => handleOpenDrawer(id)}
							className='text-yellow-500 cursor-pointer underline hover:text-yellow-600'
						>
							Trail
						</span>
					</div>
				</div>
			);
		},
		'Transit Stock': (_, item) => {
			return (
				<div className='flex items-center justify-center gap-2'>
					<span>{item}</span>
				</div>
			);
		},
		'Asset Category': (_, item) => {
			const assetCategory = assetTypes?.find((ele) => ele?.id === item)?.assetCategory?.name;
			return <span>{assetCategory}</span>;
		},
		Capacity: (_, item) => {
			const capacity = assetTypes?.find((ele) => ele?.id === item)?.capacity;
			return <span>{capacity}</span>;
		},
		Movable: (_, item) => {
			const movable = assetTypes?.find((ele) => ele?.id === item)?.mobileType;
			return (
				<div className='flex items-center justify-center'>
					{movable === 'MOVABLE' ? (
						<div className='flex items-center justify-start gap-3 w-[100px]'>
							<AirlineStopsIcon fontSize='large' />
							<span className='text-nowrap'>movable</span>
						</div>
					) : (
						<div className='flex items-center justify-start gap-3 w-[100px]'>
							<PushPinIcon fontSize='large' />
							<span className='text-nowrap'>non movable</span>
						</div>
					)}
				</div>
			);
		},
		Traceble: (_, item) => {
			const traceble = assetTypes?.find((ele) => ele?.id === item)?.traceable;
			return (
				<div className='flex items-center justify-center'>
					{traceble ? (
						<div className='text-start'>
							<WhereToVote fontSize='large' />
						</div>
					) : (
						<div className='text-start'>
							<MapPinOff fontSize='large' />
						</div>
					)}
				</div>
			);
		},
	};
	const generateData = () => {
		if (!searchValue) return data;
		return data?.filter((item) => {
			return item?.assetType.toLowerCase().includes(searchValue.toLowerCase());
		});
	};
	return (
		<div className='p-4'>
			<BackdropLoader loading={loading} setLoading={setLoading} />
			<StockHistoryDrawer />
			<h1 className='text-2xl font-bold mb-4'>Asset Report</h1>
			<div className='flex items-center gap-4 w-full'>
				<div className='w-[60%]'>
					<GlobalSearch
						searchDropDown={false}
						placeholderText='Search by Asset Type Name'
						setSearchValue={setSearchValue}
					/>
				</div>
				<SelectPicker
					placeholder='Select a Store'
					data={stores?.map((storeValue) => ({
						label: storeValue?.name,
						value: storeValue?.id,
					}))}
					className='w-[30%] ml-4'
					value={store?.id}
					onChange={selectStore}
				/>
			</div>
			<div>
				<ListTable
					data={generateData()}
					actions={SPECIAL_COLUMNS}
					special={specialItems}
					colMap={colMap}
				/>
			</div>
		</div>
	);
};

export default AssetReport;
